module.exports = __webpack_public_path__ + "img/NL480.95d58cfc.png";